const brandConstants = {
    colors: {
        primary: '#DC1226',
        primary_light: '#EC192C',
        primary_disabled: '#E5E5E5',
        secondary: '#58595B',
        secondary_dark: '#EA2028',
        light_grey: '#EFEFEF',
        error: '#C73637',
        bg_alternative: '#E5E5E5',
        bg_third: '#B3B3B3',
        bg_banner: '#FFFFFF',
        third: '#000000',
        third_light: '#A4A4A6',
        third_hover: '#8298b3',
        fourth: '#25CF22',
        white: '#ffffff',
        warning_main: '#FF9800',
        processing_status: '#FEEE0E',
        bg_processing: '#FF7400',
        bg_approved: '#00B039',
        bg_conditionally_approved: '#009C32',
        bg_conditionally_approved_border: '#C2EACF',
        bg_decline_cancelled: '#E12323',
        bg_amended: '#E5E5E5',
        bg_amended_text: '#959595',
        amended_text: '#666666',
        bg_orders: '#323334',
        bg_enquiries: '#406DBB',
    },
    fontFamilies: {
        primary: ['"Swiss 721"', 'Swiss-BT', 'Helvetica', 'sans-serif'].join(','),
        primary_bold: ['Swiss-BT', 'Roboto-Condensed', 'sans-serif'].join(','),
    },
    fontSizes: {
        xxs: 10,
        xs: 12,
        sm: 14,
        md: 16,
        lg: 20,
        xl: 24,
        xxl: 30,
    },
    screens: {
        xs: 0,
        sm: 768,
        md: 960,
        lg: 1280,
        xl: 1920,
    },
    defaultSpacing: 10,
};
export default brandConstants;
//# sourceMappingURL=brand-constants.js.map